import { FlexBox } from '@dixa/lib-shared-habla';

import { SatisfactionRatingReceivedMessage } from '../components/SatisfactionRatingReceivedMessage';

type NpsMessageProps = {
  /** NPS scores are 0-10 */
  score: number;
  /** The comment from the user */
  comment: string;
};

export const NpsRatingMessage = ({
  score,
  comment,
}: NpsMessageProps): JSX.Element => (
  <SatisfactionRatingReceivedMessage
    scoreElement={
      <FlexBox
        alignItems="center"
        justifyContent="center"
        borderRadius="8px"
        borderWidth="200"
        background="purple.100"
        borderColor="purple.400"
        width="30px"
        height="30px"
      >
        {score}
      </FlexBox>
    }
    tooltipContent={`NPS Score: ${score} out of 10`}
    ratingTypeLabel="NPS"
    comment={comment}
  />
);
